function ClientsPage() {
    return <div>This is the Clients content</div>
  }

export default ClientsPage